import { AccountPage } from "./pages/AccountPage";
import { TeamPage } from "./pages/TeamPage";
import { AdminPage } from "./pages/AdminPage";
import { AuthPage } from "./pages/AuthPage";
import { DevicePage } from "./pages/DevicePage";
import { PayDonePage } from "./pages/PayDonePage";
import { RecoveryPage } from "./pages/RecoveryPage";
import { ContactPage } from "./pages/ContactPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { SquadTacticalPlannerPage } from "./pages/SquadTacticalPlannerPage";
import { extractTeamInviteToken, resolveAppRoute } from "./app-route";

export function App() {
  switch (resolveAppRoute(window.location.pathname)) {
    case "auth":
      return <AuthPage />;
    case "account":
      return <AccountPage />;
    case "teams":
      return <TeamPage />;
    case "team-invite":
      return <TeamPage inviteToken={extractTeamInviteToken(window.location.pathname) ?? ""} />;
    case "admin":
      return <AdminPage />;
    case "recovery":
      return <RecoveryPage />;
    case "device":
      return <DevicePage />;
    case "payment-complete":
      return <PayDonePage />;
    case "squad-tactical-planner":
      return <SquadTacticalPlannerPage />;
    case "contact":
      return <ContactPage />;
    case "not-found":
      return <NotFoundPage />;
  }
}
